import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLayout from '../components/LegalPageLayout';
import api from '../services/api';

const Shipping = () => {
  const { t } = useTranslation();
  const [estimate, setEstimate] = useState(null);

  useEffect(() => {
    api.get('/api/settings/shipping')
      .then((res) => setEstimate(res.data))
      .catch(() => setEstimate(null));
  }, []);

  const notice = estimate && (
    <div className="legal-notice">
      {t('shipping.estimateNotice', {
        min: estimate.estimatedDeliveryDaysMin,
        max: estimate.estimatedDeliveryDaysMax,
      })}
    </div>
  );

  return <LegalPageLayout namespace="shipping" sectionCount={6} extra={notice} />;
};

export default Shipping;
